import Immutable from 'immutable'

import DailyMenu           from './daily_menu'
import GroupMenuWithOrders from './group_menu_with_orders'

export default class DailyMenuWithOrders extends DailyMenu
  isSaved: ->
    @groupMenus().every (groupMenu) -> groupMenu.isSaved()

  hasSelection: ->
    @groupMenus().some (groupMenu) -> groupMenu.hasSelection()

  allAdditionalMealsSelected: ->
    @groupMenus().every (groupMenu) -> groupMenu.allAdditionalMealsSelected()

  orders: ->
    menus = @_groupMenus?.map(@_groupMenuFor.bind(@)) or new Immutable.Map

    menus.filter((gm) -> not gm.isSaved()).map (gm) -> gm.orders()

  _groupMenuFor: (courseMenus, groupName) ->
    group = @_menu.groups.find(groupName)

    new GroupMenuWithOrders(@canteen, @date, group, courseMenus, @_menu)
